import { render, staticRenderFns } from "./ArticleAdmin.vue?vue&type=template&id=90910d80&"
import script from "./ArticleAdmin.vue?vue&type=script&lang=js&"
export * from "./ArticleAdmin.vue?vue&type=script&lang=js&"
import style0 from "./ArticleAdmin.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ArticleAdmin.vue"
export default component.exports